import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/application/findAll')
    return data
  },

  async getById(id) {
    const { data } = await repository.get(baseURL + '/application/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/application', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/application', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/application/' + id)
  },

  async findAllActualApplication(body) {
    const { data } = await repository.post(baseURL + '/application/findAllActualApplication/0', body)
    return data
  },

  async findAllByFilter(page, body) {
    const { data } = await repository.post(baseURL + `/application/findAllByFilter/${page}`, body)
    return data
  },

  async sendApplication(id) {
    const { data } = await repository.put(baseURL + `/application/sendApplication?applicationId=${id}`)
    return data
  },

  async acceptApplication(id) {
    const { data } = await repository.put(baseURL + `/application/acceptApplication?applicationId=${id}`)
    return data
  },

  async returnApplication(id, str) {
    const body = {
      applicationId: Number(id),
      text: str,
    }
    const { data } = await repository.put(baseURL + `/application/returnApplication`, body)
    return data
  },

  async rejectApplication(id, str) {
    const body = {
      applicationId: Number(id),
      text: str,
    }
    const { data } = await repository.put(baseURL + `/application/rejectApplication`, body)
    return data
  },

  async appointCurator(id) {
    const { data } = await repository.put(baseURL + `/application/appointCurator?applicationId=${id}`)
    return data
  },

  async copy(id) {
    const { data } = await repository.put(baseURL + `/application/copy?applicationId=${id}`)
    return data
  },

  async findAllByFullName(fullName) {
    const { data } = await repository.get(baseURL + `/application/findAllByFullName?fullName=${fullName}`)
    return data
  },

  async appointCompetition(id) {
    const { data } = await repository.put(baseURL + `/application/appointCompetition?vacancyId=${id}`)
    return data
  },

  async cancelCompetition(id) {
    const { data } = await repository.put(baseURL + `/application/cancelCompetition?vacancyId=${id}`)
    return data
  },

  async findAllByVacancy(id) {
    const { data } = await repository.post(baseURL + `/application/findAllByVacancy?vacancyId=${id}`)
    return data
  },

  async findAllForTestScore() {
    const { data } = await repository.post(baseURL + `/application/findAllForTestScore`)
    return data
  },

  async findAllForTestScoreFilter(page, body, vacancyId) {
    const { data } = await repository.post(baseURL +
      `/application/findAllForTestScoreFilter/${page}${vacancyId ? '?vacancyId=' + vacancyId : ''}`, body)
    return data
  },

  async findNotNullTestScore(applicationFilterDto) {
    const { data } = await repository.post(baseURL + `/application/findNotNullTestScore`, applicationFilterDto)
    return data
  },

  async findAllByProtocolLineFilter(filter) {
    const { data } = await repository.post(baseURL + '/application/findAllByProtocolLineFilter', filter)
    return data
  },

  async updateTestScore(body) {
    const { data } = await repository.put(baseURL + `/application/updateTestScore`, body)
    return data
  },

  async checkApplicationCreation() {
    const { data } = await repository.get(`${baseURL}/application/checkApplicationCreation`)
    return data
  },

  async deleteByApplicationIdList(idList) {
    await repository.post(`${baseURL}/application/deleteByApplicationIdList`, idList)
  },

  async deleteAllApplication(idList) {
    await repository.delete(`${baseURL}/application/deleteAllApplication`)
  }
}
